
import React, { useContext } from 'react';
import Header from '../Header/Header';
import './Layout.scss';
import Footer from '../Footer/Footer';
import { DestinationContext } from '../../contexts/DestinationContext';

const Layout = ({ children }) => {

  const destination = useContext(DestinationContext);

  return (
    <div style={{ position: "relative" }}>
      <Header destination={destination} />
      <main>{children}</main>
      <Footer />
    </div>
  )
}

export default Layout
